import React from 'react';
import { useLocation } from 'react-router';

export function withPathname(WrappedComponent) {
  return function WrappedComponentWithPathname(props) {
    const { pathname } = useLocation();
    // eslint-disable-next-line react/jsx-props-no-spreading
    return <WrappedComponent pathname={pathname} {...props} />;
  };
}
